import React from 'react';
import {Button, Col, Row } from 'reactstrap';
import DeniReactTreeView from "deni-react-treeview"
import './styleDashboard.css';
import { Dialog } from 'primereact/dialog';



export const ModalCheckSpecimen2 = (props) => {

    const {
        modalCheckSpecimen: modal, toggleCheckSpecimen: toggle,
        loadingSpecimen, treeviewRef, itemsTree, changeTree, savePendingMuestra, enable_tracking_toma
    } = props;

   
      // ? CONFIGURATION CARDS INFO
     const onRenderItem = (_find) => {
        return (
            <div className="treeview-item-example">
                {
                    _find.state === 1 && _find.check_forwarded === false ?
                        <span style={{color:"#51bb25"}} >
                            <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                              
                                
                            </span>
                            :
                    _find.state === 1 && _find.check_forwarded === true ?
                        <span>
                            <i className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                               
                                </span>
                                : 
                        <span style={{ color: '#FF8F00' }}>
                            <i style={{ color: '#FF8F00' }} className="icofont icofont-laboratory f-12"></i>{_find.text}&nbsp;
                                
                        </span>
                }
            </div>
        )
    }




    return (
        <Dialog 
            className="pt-0 custom-dialog-bussine"
            header="Actualizar Muestras Remitidas"
            visible={modal}
            style={{ width: '60vw', maxWidth: '700px' }}
            modal
            dismissableMask  
            onHide={toggle}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
                }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white'} },
                headerIcon: { style: { color: 'white' } },
                content: {style: {paddingLeft: "1px" } }
                }}
                 footer={
                    <Button size="sm" outline color="primary" type="button" onClick={() => savePendingMuestra()} className={loadingSpecimen ? "disabled progress-bar-animated progress-bar-striped" : ""}  >
                            Actualizar muestras
                        </Button>
                 }
          
             >
         
            <>
                <Col sm="12" className='pt-3' >
                    <ul className="list-group" style={{display:'-webkit-box', width:'100%'}}>
                        <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-success rounded-lg text-center font-weight-bold px-4">Con muestra</li>
                        <li style={{fontSize:"12px", maxWidth: "150px"}} className="list-group-item list-group-item-primary rounded-lg text-center font-weight-bold px-4">Remitida</li>
                        <li style={{fontSize:"12px", maxWidth: "150px", backgroundColor: '#ff8f00a6'}} className="list-group-item list-group-item rounded-lg text-center font-weight-bold px-4">Sin muestra</li>
                    </ul>
                </Col>
                <Col sm="12">
                    <Row>
                       
                        <Col sm="12"> <br />
                            <DeniReactTreeView
                                className="deni-react-treeview-container5"
                                ref={treeviewRef}
                                style={{ marginRight: '10px', marginBottom: '10px',textAlign: "center" }}
                                showCheckbox={true}
                                showIcon={false}
                                items={itemsTree}
                                onCheckItem={(e) => changeTree(e)}
                                onRenderItem={onRenderItem}
                                selectRow={false}
                            />
                        </Col>
                    </Row>
                </Col>
            </>
           
        </Dialog>
    )
}